import React from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'antd'
import { AreasStore } from 'store/areas.store'
import { UserStore } from 'store/user.store'
import { getAreaListColumns } from './area-list-columns'

export const AreaListFeature = observer(() => {

  const toggleArea = (areaId: string, status: boolean) => {
  AreasStore.toggleArea(areaId, status)
}
  return (
    <div>
      <Table
        columns={getAreaListColumns(toggleArea)}
        dataSource={AreasStore.areasSpliced}
        rowKey="id"
      />
    </div>
  )
})
